import React from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { isHost } from 'venuescanner-js/constants/user_type';

const EditButton = ({ thread, send, styles = {}, isMobile }) => (
  <IconButton
    sx={{
      border: 1,
      borderRadius: '50%',
      borderColor: '#1e0040',
      color: '#1e0040',
      marginRight: { xs: '1rem', md: 0 },
      height: isMobile ? 32 : 18,
      width: isMobile ? 32 : 18,
      ...styles,
    }}
    aria-label={isHost(thread) ? 'Edit Quote' : 'Edit Enquiry'}
    onClick={() => send({ type: 'EDIT_EVENT' })}>
    <EditIcon sx={{ height: isMobile ? 18 : 12, width: 'auto' }} />
  </IconButton>
);

EditButton.propTypes = {
  thread: PropTypes.object.isRequired,
  send: PropTypes.func.isRequired,
  styles: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default EditButton;
